import API from 'services/TAPS_API';
import { NDFL3_NOTIFICATION_ID } from '../../constants';

/**
 * Get incomes by 2NDFL id/agent list
 * @param {[]} data
 * @returns {AxiosPromise|Object}
 */
export default function getIncomeSourcesBy2Ndfl(data) {
  return API.request({
    method: 'POST',
    url: `/notification/${NDFL3_NOTIFICATION_ID}/parse2ndflBulk`,
    data,
  });
}
